module.exports = __webpack_public_path__ + "img/phone.cc9699ad.svg";